export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.18.0',
};
//# sourceMappingURL=buildEnv.js.map